export function simplifyWhiteboard(data) {
    const resp = data.filter((item) => {
        return ["addTextBox"].includes(item.t);
    });

    return resp;
}
